/**
 * subject-context-response.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { TypedDataHolder } from "../../../common/data/typed-data";
import { SubjectContextType, KnownSubjectContextTypes }
  from "../../../subjects/subject-context-type";
import { Displayable } from "../../../support/types/aliases";

import { validateAs, validateFor, validateOpaqueID, validateTSEnum }
  from "../../validation/decorators";
import { IncomingMessage } from "../general/incoming-message";
import { MessageTag } from "../message-tag";

/**
 * The server responds with a {@link SubjectContextResponse} to fulfill a
 * client request to retrieve a subject context.
 */
@validateFor(MessageTag.RSP_SUBJECT_CONTEXT)
export class SubjectContextResponse extends IncomingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.RSP_SUBJECT_CONTEXT;

  /**
   * The server timestamp for when this context was created.
   * @type {number}
   */
  @validateAs("integer")
  public created : number;

  @validateAs("object")
  public summary : {
    contextType : SubjectContextType;
    summary : Array<TypedDataHolder & Displayable>;
  };

  /**
   * The identifier of the object in the server's cache.
   */
  @validateOpaqueID()
  public objectId : number;

  /**
   * The identifier of the corresponding watchlist entry, if watched, else null.
   */
  @validateOpaqueID(false, null, true)
  public watchId : number;

  /**
   * The type of this subject context.
   */
  @validateAs({enum: Object.values(KnownSubjectContextTypes)})
  public contextType : SubjectContextType;

  /**
   * The valid algorithms for this subject context.
   */
  @validateAs({array: "string"})
  public algorithms : string[];
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/context-management/subject-context-response.ts